import { render, staticRenderFns } from "./BeNotifications.vue?vue&type=template&id=0bf476e5&"
import script from "./BeNotifications.vue?vue&type=script&lang=js&"
export * from "./BeNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BeNotifications.vue?vue&type=style&index=0&id=0bf476e5&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports